import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth-context";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Ban } from "lucide-react";

export default function SuspendedBanner() {
  const { user } = useAuth();
  const [info, setInfo] = useState<{ reason: string | null } | null>(null);

  useEffect(() => {
    if (!user) {
      setInfo(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("profiles")
        .select("is_suspended, suspension_reason")
        .eq("user_id", user.id)
        .maybeSingle();
      if (!cancelled && data?.is_suspended) {
        setInfo({ reason: data.suspension_reason ?? null });
      } else if (!cancelled) {
        setInfo(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!info) return null;

  return (
    <div className="border-b border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive">
      <div className="mx-auto flex max-w-5xl items-start gap-2">
        <Ban className="mt-0.5 h-4 w-4 shrink-0" />
        <p>
          <strong>Twoje konto jest zawieszone do wyjaśnienia.</strong> Nie możesz dodawać koszulek, postów ani
          komentarzy, a Twoje treści są ukryte dla innych użytkowników.
          {info.reason ? <> Powód: {info.reason}.</> : null}{" "}
          Skontaktuj się z administratorem przez{" "}
          <Link to="/messages" className="underline underline-offset-2">
            wiadomości prywatne
          </Link>
          .
        </p>
      </div>
    </div>
  );
}